import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PlanList } from '../../models/plan-list'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EthnicityData } from '../../models/ethnicity-data';
import { RaceData } from '../../models/race-data';
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'accessibility',
    templateUrl: 'accessibility.component.html',
    styleUrls: ['accessibility.component.scss']
})

export class AccessibilityComponent implements OnInit {

   @Input()  accessibilityValue: string
    optionaccessibility: ValidatedRadioButtonModel[] = []
    @Input() enrollment: EnrollmentViewModel = new EnrollmentViewModel()
    @Output() onValueChange: EventEmitter<any> = new EventEmitter<any>()

    constructor(private _enrollService: EnrollmentGateway, public _global: PortalGlobals) {
        this.optionaccessibility.push({ value: '2', htmlLabel: 'Braille' }, { value: '1', htmlLabel: 'Large Print' }, { value: '4', htmlLabel: 'Audio CD' })

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.optionaccessibility.push({ value: '8', htmlLabel: 'Data CD' })
        }
    }

    ngOnInit() {

        this.enrollment = this._enrollService.getEnrollmentViewModel()
        console.log("accessibility");
        console.log(JSON.stringify(this.enrollment));
        console.log(this.accessibilityValue);
        let lAccessibility = "";
        if (this.accessibilityValue != "" && this.accessibilityValue != undefined) {
            lAccessibility=this.accessibilityValue
        }
        if (lAccessibility == "1" || lAccessibility == "5") {
            this.accessibilityValue = "1";
            this.enrollment.accessibility = "1";
        }
        if (lAccessibility == "2" || lAccessibility == "6") {
            this.accessibilityValue = "2";
            this.enrollment.accessibility = "2";
        }
        if (lAccessibility == "4" || lAccessibility == "7") {
            this.accessibilityValue = "4";
            this.enrollment.accessibility = "4";
        }
        if (lAccessibility == "8" || lAccessibility == "9") {
            this.accessibilityValue = "8";
            this.enrollment.accessibility = "8";
        }
        this.onValueChange.emit(this.enrollment)

    }

    onAccessibilityChanges(value) {
        this.accessibilityValue = value;
        this.enrollment.accessibility = value;
        this.onValueChange.emit(this.enrollment)
    }

}